// @ts-strict-ignore
import type { ReactNode } from "react";
import { useRef } from "react";

import { useStaticData } from "@clinic/shared/hooks/useStaticData/useStaticData";
import { useOutsideClick } from "@shared/hooks/useOutsideClick/useOutsideClick";
import * as utilities from "@styles/emotion-styles/utilities";

import * as styles from "./Sidebar.styles";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}

const Sidebar = ({ isOpen, onClose, children }: Props) => {
  const { adminImpersonating } = useStaticData();

  const ref = useRef(null);
  useOutsideClick(ref, () => {
    if (isOpen) {
      onClose();
    }
  });

  const conditionalSidebarStyles = [
    styles.sidebar.base,
    utilities.noprint,
    isOpen && styles.sidebar.active,
    adminImpersonating && styles.sidebar.admin,
  ];

  return (
    <div css={conditionalSidebarStyles} ref={ref}>
      {children}
    </div>
  );
};

export { Sidebar };
